export default __webpack_public_path__ + "static/media/KH_Word_white.35910c0c.png";